/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';

import {
  CaretUpOutlined,
  CaretDownOutlined,
  EyeOutlined,
} from '@ant-design/icons';
import Layout from '../../../layouts/User';
import { useSearchParams } from 'react-router-dom';
import {
  Button,
  Carousel,
  Col,
  Form,
  Input,
  Card,
  message,
  Modal,
  Row,
  Typography,
  Tag,
  Divider,
  InputNumber,
} from 'antd';
import { BASE_URL, DEFAULT_PRODUCT_URL, LINE_LIFF_ID } from '../../../config';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
// import el from 'date-fns/esm/locale/el/index.js';
import Logo from '../../../components/Logo2';
import { useLiff } from 'react-liff';
import './index.css';
import { getRedirectPath } from '../../../functions';
import { logRoles } from '@testing-library/react';

export type Props = {};

const { Text, Paragraph } = Typography;

const ProductDetail: React.FC<Props> = (props) => {
  let [formWholesale] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user);
  const [imageShowH, setImageShowH] = React.useState<any>();
  const [productDetail, setProductDetail] = useState<any>({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalPolicy, setModalPolicy] = useState<boolean>(false);
  const [modalCart, setModalCart] = useState<boolean>(false);
  const [modalCondition, setModalCondition] = useState<boolean>(false);
  const [modalLogin, setModalLogin] = useState<boolean>(false);
  const [isMember, setIsMember] = useState<any>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [wholesalePrice, setWholesalePrice] = React.useState<string>('');
  let [searchParams, setSearchParams] = useSearchParams();
  const [productCart, setProductCart] = useState<any>();
  const [productCartNew, setProductCartNew] = useState<any>();
  const [cartId, setCartId] = useState<any>();
  const [fromPage, setFromPage] = useState<any>('');
  const [navigateBarName, setNavigateBarName] = useState<any>();
  const [navigateBarUrl, setNavigateBarUrl] = useState<any>();
  const [cartValue, setCartValue] = useState<number>(1);
  const [tagProduct, setTagProduct] = useState<any>([]);

  // const { error, liff, isLoggedIn, ready } = useLiff();
  const [displayName, setDisplayName] = useState('');
  const [profile, setProfile] = useState<any>({});
  const [isFinishedLoad, setIsFinishedLoad] = useState<boolean>(false);
  const [isLoggedIn, setIsLoggedIn] = useState(
    localStorage.getItem('token') !== undefined &&
      localStorage.getItem('token') !== null
  );

  const [state, setState] = useState<any>({
    wholesale: [
      {
        min: null,
        max: null,
        price: null,
      },
    ],
  });

  const { confirm } = Modal;

  const breadcrumbs = [
    {
      text: 'หน้าแรก',
      path: '/',
    },
    {
      text: navigateBarName ? `${navigateBarName}` : '',
      path: `${navigateBarUrl}`,
    },
    {
      text: ` ${productDetail?.shop?.name}`,
      path: `/shops/?from=${fromPage}&id=${productDetail?.shop?._id}`,
    },
    {
      text: `${productDetail?.product?.productName}`,
    },
  ];
  const getApi = async () => {
    getProductDetail(searchParams.get('id'));
  };

  const getProductDetail = async (productId: any) => {
    const productDetail = await axios.get(
      `${BASE_URL}/user-product/get-product-detail/${productId}`
    );
    if (productDetail?.data?.wholesale) {
      setWholesale(productDetail?.data?.wholesale);
    }
    setState({ wholesale: productDetail?.data?.wholesale });
    setProductDetail(productDetail.data);
    getTagProduct(productDetail.data);
  };

  const getNavigateBarName = async () => {
    setFromPage(searchParams.get('from'));
    const page = searchParams.get('from');
    switch (page) {
      case 'nearMe':
        setNavigateBarName('ร้านค้าใกล้ฉัน');
        setNavigateBarUrl('/shops/near-me');
        break;
      case 'myShops':
        setNavigateBarName('ร้านค้าของฉัน');
        setNavigateBarUrl('/my-shops');
        break;
      case 'categories':
        setNavigateBarName('หมวดหมู่สินค้า');
        setNavigateBarUrl('/product-categories');
        break;
      default:
        setNavigateBarName('ร้านค้า');
        setNavigateBarUrl('');
        break;
    }
  };

  const getTagProduct = async (productDetail: any) => {
    if (productDetail.product?.code) {
      const url = `/tags/getTagProduct`;
      const productData = {
        productCode: productDetail.product?.code,
      };

      const { data } = await axios.post(url, productData);
      if (data.length > 0) {
        setTagProduct(data);
      }
    }
  };

  const setWholesale = (value: any) => {
    let wholesalePrice = [];
    wholesalePrice = value.map((x: any) => x.price);
    const min = Math.min(...wholesalePrice);
    const max = Math.max(...wholesalePrice);
    if (wholesalePrice[0] === undefined) {
      const text = `-`;
      setWholesalePrice(text);
    } else if (wholesalePrice[1] === undefined) {
      const text = `฿ ${max}`;
      setWholesalePrice(text);
    } else {
      const text = `฿ ${min}-${max}`;
      setWholesalePrice(text);
    }
  };

  const confirmButton = async (values: any) => {
    if (!isEmpty(user)) {
      if (values === '') {
        message.warning('จำนวนสินค้า ไม่ถูกต้อง');
      } else if (values === '0') {
        message.warning('ปริมาณสินค้าห้ามต่ำกว่า 1');
      } else if (productDetail.stock < values) {
        message.warning('ปริมาณสินค้าใน stock ไม่เพียงพอ');
      } else {
        setLoading(true);
        const dataCreate = {
          userId: user._id,
          shops: [
            {
              shop: productDetail?.shop?._id,
              products: [
                {
                  product: productDetail?._id,
                  amount: values,
                },
              ],
            },
          ],
        };
        const dataUpdate = {
          userId: user._id,
          shops: {
            shop: productDetail?.shop?._id,
            products: {
              product: productDetail?._id,
              amount: values,
            },
          },
        };

        try {
          const getOrderId = await axios.get(`carts/${user?._id}`);
          const isCartProduct = checkcartProduct(getOrderId.data);
          setCartId(getOrderId);
          setProductCart(dataUpdate);
          setProductCartNew(dataCreate);

          if (!isCartProduct) {
            // updateCart(getOrderId, dataCreate, dataCreate)
            const resultCreate = await axios.post(`carts`, dataCreate);
            const getOrderId = await axios.get(`carts/${user?._id}`);
            if (getOrderId.data) {
              if (resultCreate.data.status !== 'OK') {
                await axios.patch(
                  `/carts/${getOrderId?.data?._id}`,
                  dataUpdate
                );
              }

              message.success(`เพิ่มลงตะกร้าสินค้าเรียบร้อยแล้ว`);
              setTimeout(() => {
                navigate('/cart');
              }, 1000);
            } else {
              message.error('เกิดข้อผิดพลาดในการเพิ่มตะกร้าสินค้า! CODE:11001');
              setLoading(false);
            }
          }
        } catch (err) {
          // console.log('err =>', err);
          message.error('เกิดข้อผิดพลาดในการเพิ่มตะกร้าสินค้า!');
          setLoading(false);
        }
      }
    } else {
      setModalLogin(true);
    }
  };

  const updateCart = async (
    getOrderId: any,
    dataCreate: any,
    dataUpdate: any
  ) => {
    await axios.post(`carts`, dataCreate);
    if (getOrderId.data) {
      await axios.patch(`/carts/${getOrderId?.data?._id}`, dataUpdate);
      message.success(`เพิ่มลงตะกร้าสินค้าเรียบร้อยแล้ว`);
      setTimeout(() => {
        navigate('/cart');
      }, 1000);
    } else {
      message.error('เกิดข้อผิดพลาดในการเพิ่มตะกร้าสินค้า! CODE:11001');
      setLoading(false);
    }
  };

  const convertPrice = (value: any) => {
    value = value || 0;
    return value
      .toFixed(2)
      .toString()
      .replace(/\D/g, '')
      .replace(/(\d)(\d{2})$/, '$1.$2')
      .replace(/(?=(\d{3})+(\D))\B/g, ',');
  };

  const checkcartProduct = (items: any) => {
    if (items?.shops.length > 0) {
      let shop = { ...items.shops[0] };
      if (shop?.shop._id !== productDetail?.shop?._id) {
        setModalCart(true);
        return true;
      }
    } else {
      return false;
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleCartOk = async () => {
    const bodyCart = {
      userId: user?._id,
      shops: [],
    };
    await axios.patch(`/carts/new-cart/${cartId?.data?._id}`, bodyCart);

    setModalCart(false);
    updateCart(cartId, productCartNew, productCart);
  };

  const handleCartCancel = () => {
    setModalCart(false);
    setLoading(false);
  };

  const inputCartDown = () => {
    if (cartValue > 1) {
      setCartValue((prev) => prev - 1);
    }
  };

  const inputCartUp = () => {
    if (cartValue < productDetail.stock) {
      setCartValue((prev) => prev + 1);
    }
  };

  const checkMemberShop = async (userId: any) => {
    const shopMember = await axios.get(
      `${BASE_URL}/shop-buyer/shop-buyer-member/${userId}?shop=${productDetail?.shop?._id}`
    );

    setIsMember(shopMember?.data);
  };

  const addDefaultImage = async (ev: any) => {
    if (!ev.target.errored) {
      ev.target.errored = true;
      ev.target.src = DEFAULT_PRODUCT_URL;
    }
  };

  useEffect(() => {
    if (productDetail) {
      if (productDetail?.product?.files.length) {
        const listItems = productDetail?.product?.files.map(
          (x: any, index: number) => (
            <React.Fragment key={index}>
              <div>
                <img
                  className={styles.wrapper}
                  width={'100%'}
                  style={{ marginBottom: 50 }}
                  src={x}
                  onError={async (e) => {
                    await addDefaultImage(e);
                  }}
                ></img>
              </div>
            </React.Fragment>
          )
        );
        setImageShowH(listItems);
      }

      if (user?._id && productDetail?.shop?._id) {
        checkMemberShop(user?._id);
      }
    }
  }, [productDetail]);

  useEffect(() => {
    formWholesale.setFieldsValue({ ...state });
  }, [state]);

  useEffect(() => {
    getApi();
    getNavigateBarName();
    formWholesale.setFieldsValue({
      wholesale: [{}],
    });
  }, []);

  const showDisplayName = () => {
    if (!isLoggedIn) {
      return (
        <Button
          type='primary'
          className='App-button'
          onClick={() => {
            login();
          }}
        >
          เข้าสู่ระบบ
        </Button>
      );
    }
    return (
      <>
        <p>ยินดีต้อนรับเข้าสู่เว็บไซต์ Promptdee, {displayName}!</p>
      </>
    );
  };

  const login = () => {
    // const path = '/login';
    // navigate(path);

    navigate(`/login?redirect=${searchParams.get('redirect')}`);

    // liff
    //   .init({ liffId: LINE_LIFF_ID ? LINE_LIFF_ID : "" })
    //   .then(async () => {
    //     if (liff.isLoggedIn()) {
    //       console.log('------>',liff.getProfile());
    //     } else {
    //       liff.login();
    //       loginUser();
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  };

  return (
    <>
      <Layout breadcrumbItems={breadcrumbs} breadcrumbMarginBottom={50}>
        <div style={{ marginBottom: '20px' }}>
          <Row>
            <Col xs={24} sm={24} md={9} lg={9}></Col>
            <Col xs={24} sm={24} md={6} lg={6}>
              <Carousel
                touchMove={true}
                draggable={true}
                swipeToSlide={true}
                touchThreshold={50}
                focusOnSelect={true}
                autoplay
              >
                {imageShowH}
              </Carousel>
              {productDetail?.product?.files.length > 1 && (
                <Carousel
                  slidesToShow={
                    productDetail?.product?.files.length === 2 ? 2 : 3
                  }
                  draggable={true}
                  swipeToSlide={true}
                  touchThreshold={50}
                  focusOnSelect={true}
                  dots={false}
                >
                  {imageShowH}
                </Carousel>
              )}
            </Col>
            <Col xs={24} sm={24} md={9} lg={9}></Col>
          </Row>

          <Row>
            <Col span={24}>
              <Text className={styles.titleName}>
                <strong>
                  {productDetail?.product?.productName}&nbsp;
                  {productDetail?.product?.productLocalName
                    ? `(${productDetail?.product?.productLocalName})`
                    : ``}
                </strong>
              </Text>
            </Col>

            <Col span={24}>
              <Text type='secondary' className={styles.textSecondary}>
                ยี่ห้อ {productDetail?.product?.brand?.name}
              </Text>
            </Col>
            <Col span={24} style={{ marginBottom: '10px' }}>
              {tagProduct.length > 0 && (
                <>
                  {tagProduct.map((item: any, index: number) => (
                    <React.Fragment key={index}>
                      {index === 0 ? (
                        <Tag
                          color={item.tagColor}
                          className={styles.tagProduct}
                        >
                          {item.tagName}
                        </Tag>
                      ) : (
                        <Tag
                          color={item.tagColor}
                          className={styles.tagProduct}
                        >
                          {item.tagName}
                        </Tag>
                      )}
                    </React.Fragment>
                  ))}
                </>
              )}
            </Col>

            <Col xs={12} md={12} className={styles.lh115}>
              <Text type='secondary' className={styles.textSecondary}>
                ราคา / ชิ้น
              </Text>
              <div style={{ fontSize: 18 }}>
                ฿&nbsp;
                {isMember ? (
                  <>
                    <strong>
                      {convertPrice(productDetail.memberPrice)}&nbsp;
                    </strong>
                    <span
                      style={{
                        textDecoration: 'line-through',
                        fontSize: '12px',
                        color: 'red',
                      }}
                    >
                      {convertPrice(productDetail.price)}
                    </span>
                  </>
                ) : (
                  <span>{convertPrice(productDetail.price)}</span>
                )}
              </div>

              {productDetail?.isShowWholeSalePrice && (
                <div style={{ marginTop: '5px' }}>
                  <Text type='secondary' className={styles.textSecondary}>
                    ราคาขายส่ง
                  </Text>
                  <br />
                  <Text type='secondary' className={styles.textSecondary}>
                    {wholesalePrice}
                    <Button type='link' size='small' onClick={showModal}>
                      <EyeOutlined />
                    </Button>
                  </Text>
                </div>
              )}
            </Col>
            <Col
              xs={{ span: 11, offset: 1 }}
              md={{ span: 6, offset: 6 }}
              lg={{ span: 5, offset: 7 }}
              xl={{ span: 3, offset: 9 }}
              className={styles.lh115}
            >
              <Text
                type='secondary'
                className={styles.textSecondary}
                style={{ color: 'gray' }}
              >
                คลังสินค้า: &nbsp;
                {productDetail?.stock < 1 ? (
                  <Text type='danger'>สินค้าหมด</Text>
                ) : (
                  <>{productDetail?.stock}</>
                )}
              </Text>

              <InputNumber
                addonBefore={<CaretDownOutlined onClick={inputCartDown} />}
                addonAfter={<CaretUpOutlined onClick={inputCartUp} />}
                controls={false}
                defaultValue={1}
                min={1}
                max={productDetail?.stock}
                disabled={productDetail?.stock < 1}
                value={cartValue}
                readOnly
                style={{ width: '100%' }}
              />
              <Button
                type='primary'
                loading={loading}
                onClick={async () => await confirmButton(cartValue)}
                disabled={productDetail?.stock < 1}
                block
                style={{ marginTop: '5px' }}
              >
                เพิ่มลงตะกร้า
              </Button>
            </Col>

            <Divider className={styles.divider} />
          </Row>

          <Row className={styles.lh115}>
            <Col span={24}>
              <Text className={styles.textNormal}>
                <strong>รายละเอียดสินค้า</strong>
              </Text>
              <Paragraph className={styles.textSecondary}>
                {productDetail?.product?.detail}
              </Paragraph>
            </Col>

            <Col span={24} style={{ marginBottom: '14px' }}>
              <Text className={styles.textSecondary}>
                <strong>น้ำหนักสินค้า</strong> &nbsp;
                {productDetail?.product?.productWeight} กิโลกรัม
              </Text>
            </Col>

            <Col span={24}>
              <Text className={styles.textSecondary}>
                <strong>หมวดหมู่</strong> &nbsp;
                {productDetail?.product?.category && (
                  <>{productDetail?.product?.category?.name} / </>
                )}
                {productDetail?.product?.subcategory && (
                  <>{productDetail?.product?.subcategory?.name} / </>
                )}
                {productDetail?.product?.class && (
                  <>{productDetail?.product?.class?.name} / </>
                )}
                {productDetail?.product?.subclass && (
                  <>{productDetail?.product?.subclass?.name} </>
                )}
              </Text>
            </Col>

            <Divider className={styles.divider} />
          </Row>

          <Row>
            <Col span={24} style={{ marginBottom: '10px' }}>
              <Text className={styles.textSecondary}>
                <strong>ขายโดย</strong> &nbsp;
                <img
                  className={styles.logoInParagraph}
                  src={productDetail?.shop?.document?.shopImageUrl}
                  alt=''
                />
                {productDetail?.shop?.name}
              </Text>
            </Col>

            <Col span={24}>
              <Text className={styles.textSecondary}>
                นโยบายการเปลี่ยน / คืน
              </Text>
              <Button
                type='link'
                size='small'
                onClick={() => {
                  setModalPolicy(true);
                }}
              >
                <EyeOutlined />
              </Button>
            </Col>

            <Col span={24}>
              <Text className={styles.textSecondary}>เงื่อนไขการจัดส่ง</Text>
              <Button
                type='link'
                size='small'
                onClick={() => {
                  setModalCondition(true);
                }}
              >
                <EyeOutlined />
              </Button>
            </Col>
          </Row>
        </div>

        <Modal
          closable={false}
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={null}
          width={400}
        >
          <p className={`${styles.text16px}`}>ขายส่ง</p>
          <div style={{ flexWrap: 'wrap', gridGap: '28px 14px' }}>
            <Form
              className={`${styles.modalform}`}
              form={formWholesale}
              onFinish={setWholesale}
              layout='vertical'
            >
              <Form.List name='wholesale'>
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(
                      ({ key, name, fieldKey, ...restField }: any) => (
                        <Row key={key}>
                          <Col span={7}>
                            <Form.Item
                              {...restField}
                              name={[name, 'min']}
                              fieldKey={[fieldKey, 'min']}
                              label={`จำนวนสั่งซื้อขั้นต่ำ`}
                              rules={[
                                {
                                  required: false,
                                  message: 'กรุณากรอกข้อมูล!',
                                },
                              ]}
                            >
                              <Input
                                type='number'
                                value={`min`}
                                name='min'
                                placeholder='0'
                                disabled
                              />
                            </Form.Item>
                          </Col>
                          <Col span={1} className={`${styles.center}`}>
                            <br />-
                          </Col>
                          <Col span={7}>
                            <Form.Item
                              {...restField}
                              name={[name, 'max']}
                              fieldKey={[fieldKey, 'max']}
                              label={`จำนวนสั่งซื้อสูงสุด`}
                              rules={[
                                {
                                  required: false,
                                  message: 'กรุณากรอกข้อมูล!',
                                },
                              ]}
                            >
                              <Input
                                type='number'
                                value={`max`}
                                name='max'
                                placeholder='0'
                                disabled
                              />
                            </Form.Item>
                          </Col>
                          <Col span={1} className={`${styles.center}`}>
                            <br />:
                          </Col>
                          <Col span={7}>
                            <Form.Item
                              {...restField}
                              name={[name, 'price']}
                              fieldKey={[fieldKey, 'price']}
                              label={`ราคาสินค้า`}
                              rules={[
                                {
                                  required: false,
                                  message: 'กรุณากรอกข้อมูล!',
                                },
                              ]}
                            >
                              <Input
                                style={{ marginTop: '22px' }}
                                type='number'
                                value={`price`}
                                name='price'
                                placeholder='0'
                                disabled
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      )
                    )}
                  </>
                )}
              </Form.List>
            </Form>
          </div>
        </Modal>

        <Modal
          visible={modalCart}
          onOk={handleCartOk}
          onCancel={handleCartCancel}
          okText={'เปลี่ยน'}
          cancelText={'ไม่เปลี่ยน'}
        >
          <div
            style={{
              textAlign: 'center',
              padding: '20px 0px 5px 0px',
              fontSize: '15px',
            }}
          >
            <h3>
              มีสินค้าร้านอื่นอยู่ในตะกร้า <br /> คุณต้องการเปลี่ยนร้านหรือไม่ ?
            </h3>
          </div>
        </Modal>

        <Modal
          title='นโยบายการเปลี่ยน / คืน'
          visible={modalPolicy}
          footer={[
            <Button
              key='submit'
              type='primary'
              loading={loading}
              onClick={() => {
                setModalPolicy(false);
              }}
            >
              ตกลง
            </Button>,
          ]}
          centered
          max-width={400}
          max-height={400}
          closeIcon
        >
          <div>
            <Card
              bordered={false}
              style={{ overflow: 'auto', height: '250px' }}
            >
              <p className={styles.pre_wrap} style={{ fontSize: 16 }}>
                {productDetail?.shop?.exchangeReturnPolicy
                  ? productDetail?.shop?.exchangeReturnPolicy
                  : '(โปรดติดต่อร้านค้า)'}
              </p>
            </Card>
          </div>
        </Modal>

        <Modal
          title='เงื่อนไขการจัดส่ง'
          visible={modalCondition}
          footer={[
            <Button
              key='submit'
              type='primary'
              loading={loading}
              onClick={() => {
                setModalCondition(false);
              }}
            >
              ตกลง
            </Button>,
          ]}
          centered
          max-width={400}
          max-height={400}
          closeIcon
        >
          <div>
            <Card
              bordered={false}
              style={{ overflow: 'auto', height: '250px' }}
              // onScroll={() => onScroll()}
            >
              <p className={styles.pre_wrap} style={{ fontSize: 16 }}>
                {productDetail?.shop?.deliveryTerms
                  ? productDetail?.shop?.deliveryTerms
                  : '(โปรดติดต่อร้านค้า)'}
              </p>
            </Card>
          </div>
        </Modal>

        <Modal
          closable={false}
          visible={modalLogin}
          onCancel={() => {
            setModalLogin(false);
          }}
          footer={null}
          className='modalStyle'
        >
          <div className={styles.pageWrapper}>
            <div className={styles.logoWrapper}>
              <Logo />
            </div>
            <h1 className={styles.header}>เข้าสู่ระบบพร้อมดี</h1>
            <p className={styles.header}>
              (กรุณาลงทะเบียนหลังกดเข้าระบบหากยังไม่เป็นสมาชิก)
            </p>
            <div className={styles.bodyWrapper}>{showDisplayName()}</div>
            <div style={{ paddingTop: '10px' }}></div>
          </div>
        </Modal>
      </Layout>
    </>
  );
};
export default ProductDetail;
